// extracted by mini-css-extract-plugin
export default {"itemLink":"columnListPopover_itemLink__Zyfs5","popoverContent":"columnListPopover_popoverContent__XAaGL"};